import type { Chapter } from './types';

/**
 * Nilai `chapterId` yang harus dikirim ke backend `/api/v1/video`.
 *
 * Upstream QuickPlay tidak konsisten antar platform. Bentuk `chapter.id`
 * yang teramati:
 *  - DramaBox: `"1"`, `"2"`         → all-digit, == index → pakai INDEX
 *  - Netshort: `"1992128909049172000"` → all-digit big-int → pakai INDEX
 *  - RapidTV:  `"1598404"`          → all-digit ≠ index → pakai INDEX
 *  - FreeReels:`"1:bdZ2X3bnTY"`     → `<index>:<hash>` → pakai INDEX
 *  - WeTV:     `"j00467e65u4"`      → alfanumerik murni → pakai ID apa adanya
 *
 * Aturan: hanya id yang **alfanumerik murni & mengandung huruf** (pola
 * WeTV) yang dikirim apa adanya. Semua bentuk lain (all-digit, atau ada
 * separator seperti `:`) → kirim episode INDEX. Ini mencegah id ber-`:`
 * (freereels) menembus schema backend `[A-Za-z0-9_-]` (400) dan cocok
 * dengan apa yang tiap upstream harapkan.
 */
export function chapterIdForUrl(c: Chapter): string {
  const isPureAlnum = /^[A-Za-z0-9]+$/.test(c.id);
  const hasLetter = /[A-Za-z]/.test(c.id);
  if (isPureAlnum && hasLetter) return c.id; // pola WeTV
  return String(c.index);
}
